import React from "react";
import { useNavigate } from "react-router-dom";
import { LifeBuoy } from "lucide-react";
import { api } from "@/lib/api";

// Floating help button shown on every client-space page. Opens the AI coach
// pre-filled with the current context so it replies with ONE simple next action.
export function StuckButton({ context }) {
  const navigate = useNavigate();
  const onClick = async () => {
    const label = context || "mon espace";
    try { await api.post("/space/event", { type: "stuck_click", label }); } catch (e) {}
    const msg = `Je suis bloqué sur ${label}. Donne-moi UNE seule petite action simple à faire tout de suite.`;
    navigate(`/coach?stuck=${encodeURIComponent(msg)}`);
  };
  return (
    <button onClick={onClick} data-testid="stuck-button" className="stuck-fab" aria-label="Je suis bloqué">
      <LifeBuoy size={18} aria-hidden="true" />
      <span className="stuck-fab-text">Je suis bloqué</span>
    </button>
  );
}
